import * as exports0 from './Arrow.dom.js';
import * as exports1 from './util/int.js';
Object.assign(arguments[0], exports0);